export interface IEmailProblem {
    id: number;
    email: string;
    problemType: EmailProblemType;
    numberOfRetry: number;
    verificationToken?: string;
    bounceSubType?: string;
    status?: string;
    diagnosticCode?: string;
}

export enum EmailProblemType {
    SoftBounce = 1,
    HardBounce = 2,
    Complaint = 3
}

export interface IEmailProblemSummary {
    email: string;
    problemType: EmailProblemType;
    verificationStarted: boolean;
    bounceSubType?: string;
    status?: string;
    diagnosticCode?: string;
} 